import { Fragment, type FC, type ReactNode } from 'react'
import { Inline } from '@leroy-merlin-br/backyard-react'
import { Sidebar } from 'user/components/Sidebar'

import LoyaltySubmenuHorizontal from 'scripts/react-components/user/components/LoyaltySubmenuHorizontal/LoyaltySubmenuHorizontal'

import { HeaderContainer } from 'lmcv/containers/Header'

import * as S from './styled'

type AuthLayoutProps = {
  children: ReactNode
  isLysUser?: boolean
  mdmClientNumber?: number
  programType: number
  userOccupation: string
  lysHomepageEnabled: boolean
}

const AuthLayout: FC<AuthLayoutProps> = ({
  children,
  mdmClientNumber,
  isLysUser = false,
  userOccupation,
  lysHomepageEnabled,
  programType
}) => {
  return (
    <S.Container>
      <S.Wrapper>
        <Inline wrap="nowrap">
          <Sidebar
            mdmClientNumber={mdmClientNumber}
            userOccupation={userOccupation}
            lysHomepageEnabled={lysHomepageEnabled}
          />
          <Fragment>
            {!isLysUser && <HeaderContainer />}

            <LoyaltySubmenuHorizontal
              mdmClientNumber={mdmClientNumber}
              isLysUser={isLysUser}
              programType={programType}
              userOccupation={userOccupation}
            />

            {children}
          </Fragment>
        </Inline>
      </S.Wrapper>
    </S.Container>
  )
}

export default AuthLayout
